import {watch,computed, defineComponent, onMounted, reactive, ref, toRaw, toRefs} from "vue";
import {Form, message} from "ant-design-vue";
import {rules} from "./budget-add.constant";
import {QuantityRecord} from "@/views/work-manage/progress/progress.interface";
import _ from "lodash";
import NP from "number-precision";

export default defineComponent({
  isGlobal: true,
  name: "BudgetAdd",
  props: {
    value: { type: String, default: undefined },
    projectId:{
      type:String,
      default:''
    }
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const state = reactive({
      visible:false,
      formRules:rules,
      formRef: ref(),
      formModel: new QuantityRecord(),
      budgetTotalPrice:computed(()=>{
        let total = NP.times(state.formModel.budgetCount || 0, state.formModel.budgetPrice || 0);
        state.formModel.budgetTotalPrice = NP.round(total,2) 
        return state.formModel.budgetTotalPrice
      })
    });
    const { resetFields,validate,validateInfos } = Form.useForm(state.formModel, state.formRules);
    //弹框显示时重置form表单
    watch(()=>state.visible,(n)=>{
      if(n){
        resetFields()
      }
    })

    const submit = async (keep) => {
        await validate()
        //如果是新增的，要把isAdd标识设置为true，用于表格改变背景色
        state.formModel.isAdd=true
        emit('change',_.cloneDeep(state.formModel))
        resetFields()
        if(0==keep){
          state.visible = false;
        }
    };


    return {
      ...toRefs(state),
      submit,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      validateInfos
    };
  },
});
